export const sourceLabel = (source, fallback = "") => {
  const labels = {
    gauls: "山寨1号机",
    unknown: "山寨2号机",
  };
  return labels[source] || fallback || source;
};

export const resultLabel = (value) => ({
  FULL_WIN: "全部止盈",
  PARTIAL_WIN: "部分盈利",
  PARTIAL_WIN_THEN_BE: "部分盈利后保本",
  MANUAL_PROFIT_CLOSE: "手动盈利平仓",
  BREAKEVEN: "保本",
  LOSS: "止损亏损",
  MANUAL_LOSS_CLOSE: "手动认亏平仓",
  CANCELLED: "已取消",
  NOT_TRIGGERED: "未触发入场",
  OPEN: "进行中",
  AMBIGUOUS: "无法判定",
  UNVERIFIED: "未验证",
  MATCH: "行情一致",
  MISMATCH: "行情不一致",
  EXCHANGE_CONFLICT: "交易所冲突",
  MARKET_DATA_UNAVAILABLE: "无可用行情",
}[value] || value || "—");

export const marketTypeLabel = (value) => ({
  spot: "现货", contract: "永续合约", unknown: "未知",
}[value] || value || "—");

export const directionLabel = (value) => ({
  long: "做多", short: "做空",
}[value] || value || "—");

export const entrySourceLabel = (value) => ({
  KOL_EXPLICIT: "原文明确价格",
  KOL_RANGE: "原文入场区间",
  MARKET_SNAPSHOT: "市场实时快照",
  HISTORICAL_ESTIMATE: "原帖时间历史估算",
  PENDING_MARKET_LOOKUP: "等待市场查询",
}[value] || value || "—");

export const qualityLabel = (value) => ({
  DUAL_SOURCE: "双交易所",
  SINGLE_SOURCE: "单交易所",
}[value] || value || "—");

export const serviceLabel = (value) => ({
  Running: "运行中", Stopped: "已停止",
}[value] || value || "加载中");

export const telegramLabel = (value) => ({
  Connected: "已连接", Error: "连接异常",
}[value] || value || "加载中");

export const sourceStatusLabel = (value) => ({
  ok: "正常", init: "初始化", error: "异常", unavailable: "不可用",
  ONLINE: "在线", NO_NEW_POST: "暂无新帖", PARSE_ERROR: "解析异常",
  FETCH_ERROR: "抓取异常", STALE: "来源陈旧", BLOCKED: "公开访问受阻",
  NEWNESS_UNVERIFIED: "新旧状态无法确认",
}[value] || value || "未知");